import React from 'react';
import styled from 'styled-components';
// import { useTranslation } from 'react-i18next';
import { useGlobalStateValue } from '../../store/globalState';
import { useTranslation } from '../../utils';

const Title = styled.h3`
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: normal;
  text-align: left;
  margin: 0;
  color: #000;
  @media screen and (max-width: 600px) {
    font-size: 20px;
    text-align: center;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 1.75rem;
  @media screen and (max-width: 600px) {
    font-size: 13px;
    margin-bottom: 1.5rem;
    text-align: center;
  }
`;

export const OrderHeader = () => {
  const {
    state: { returnQuery },
  } = useGlobalStateValue();
  const { t } = useTranslation();
  // const country = getCountryCodeFromUrl();
  return (
    <React.Fragment>
      <Title>
        {t('returnOrder')} <span>{returnQuery?.orderNumber || ''}</span>
      </Title>
      <Description>
        {t('orderHeaderDescription')}{' '}
        {/* <a href={`https://www.clasohlson.com/${country}/store-finder`}>{t('clickHere')}</a>{' '}
        {t('orderHeaderDescriptionContinue')} */}
      </Description>
    </React.Fragment>
  );
};
